/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Videos/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Preview from './Preview/index'
import React from 'react'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import VideosTree from './VideosTree/index'



/** @type {import('Simple/types.js').View} */
export default function Videos({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Images/Videos"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 width="100%"
 flexGrow={1}
 flexShrink={1}
 flexBasis="100%"
 marginTop={0}
>
{childProps => (
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 paddingTop={dtSpaceXs}
 paddingBottom={dtSpaceXs}
 paddingLeft={dtSpaceXs}
 paddingRight={dtSpaceXs}
>
{childProps => (
<React.Fragment>
<VideosTree
{...childProps}
  viewPath={`${viewPath}/VideosTree`}
/>
<Preview
{...childProps}
  viewPath={`${viewPath}/Preview`}
/>
</React.Fragment>
)}
</TysiaCardContent>
)}
</TysiaCard>
{children}
</React.Fragment>)
}